<script>
  export let customClass = '';
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  width="17"
  height="16"
  viewBox="0 0 17 16"
  fill="none"
  class={customClass}
  ><path
    stroke="#F04438"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="1.33333"
    d="M8.5612 5.3335v2.66666m0 2.66664h.00666m6.66004-2.66664c0 3.68194-2.9848 6.66664-6.6667 6.66664-3.6819 0-6.66667-2.9847-6.66667-6.66664 0-3.6819 2.98477-6.66666 6.66667-6.66666 3.6819 0 6.6667 2.98476 6.6667 6.66666Z"
  /></svg
>
